// Syntetizované náhrady zvuků Kolonie (do vygenerování přes ElevenLabs a výběru na posluchačské stránce).
import { noise, registerSynth, tone } from "../../audio.ts";

registerSynth("kolonie-kostky", (c, o, t) => {
  for (let i = 0; i < 5; i++) noise(c, o, t + i * 0.06, 0.05, { freq: 2500 + i * 300, q: 2, gain: 0.25 });
  return 0.35;
});
registerSynth("kolonie-misto", (c, o, t) => {
  tone(c, o, t, 1320, 0.06, { type: "sine", gain: 0.12, attack: 0.003 });
  return 0.07;
});
registerSynth("kolonie-stavba", (c, o, t) => {
  noise(c, o, t, 0.08, { freq: 300, q: 1, gain: 0.4 });
  tone(c, o, t + 0.08, 660, 0.15, { type: "triangle", gain: 0.25 });
  tone(c, o, t + 0.16, 990, 0.2, { type: "triangle", gain: 0.25 });
  return 0.4;
});
registerSynth("kolonie-suroviny", (c, o, t) => {
  tone(c, o, t, 1046, 0.12, { type: "sine", gain: 0.25 });
  tone(c, o, t + 0.08, 1568, 0.18, { type: "sine", gain: 0.2 });
  return 0.28;
});
registerSynth("kolonie-pirati", (c, o, t) => {
  tone(c, o, t, 196, 0.35, { type: "sawtooth", gain: 0.12, to: 147 });
  tone(c, o, t + 0.05, 233, 0.35, { type: "sawtooth", gain: 0.08, to: 175 });
  return 0.45;
});
registerSynth("kolonie-okraden", (c, o, t) => {
  tone(c, o, t, 880, 0.25, { type: "square", gain: 0.1, to: 330 });
  return 0.3;
});
registerSynth("kolonie-nabidka", (c, o, t) => {
  tone(c, o, t, 784, 0.12, { type: "triangle", gain: 0.3 });
  tone(c, o, t + 0.14, 784, 0.12, { type: "triangle", gain: 0.3 });
  return 0.3;
});
registerSynth("kolonie-obchod", (c, o, t) => {
  [659, 784, 1046].forEach((f, i) => tone(c, o, t + i * 0.06, f, 0.15, { type: "triangle", gain: 0.22 }));
  return 0.3;
});
registerSynth("kolonie-odhod", (c, o, t) => {
  tone(c, o, t, 440, 0.15, { type: "square", gain: 0.1 });
  tone(c, o, t + 0.17, 440, 0.15, { type: "square", gain: 0.1 });
  tone(c, o, t + 0.34, 440, 0.15, { type: "square", gain: 0.1 });
  return 0.5;
});
registerSynth("kolonie-bonus", (c, o, t) => {
  [523, 784, 1046, 1318].forEach((f, i) => tone(c, o, t + i * 0.08, f, 0.2, { type: "triangle", gain: 0.2 }));
  return 0.5;
});
registerSynth("kolonie-vyzkum", (c, o, t) => {
  [880, 1175, 1568].forEach((f, i) => tone(c, o, t + i * 0.05, f, 0.12, { type: "sine", gain: 0.18 }));
  return 0.25;
});
